export default {"src":"/_next/static/media/money_64.621d456d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};